import { Box, Text } from '@wix/design-system';
import React from 'react';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';

export interface EnterpriseFeaturesItemData {
  title: string;
  body: string;
  link?: string;
}

export const EnterpriseBannerFeatureItem: React.FC<
  EnterpriseFeaturesItemData
> = ({ title, body }) => {
  const { t } = EclipsePackagePickerModule.internals.useTranslations();
  return (
    <Box direction="vertical">
      <Text weight="bold" size="small">
        {t(title)}
      </Text>
      <Box marginTop="3px">
        <Text size="small">{t(body)}</Text>
      </Box>
    </Box>
  );
};
